import { useTranslation } from "react-i18next";
import { generatePath, Link } from "react-router-dom";
import routing from "routing";
import { TextBlackButton } from "src/components/Default/LekUI/Button";
import type { FolderItemsSectionProps } from "./types";

export const FolderItemsSection = ({
	title,
	type,
	folderId,
	isVisible,
	children,
}: FolderItemsSectionProps) => {
	const { t } = useTranslation();

	if (!isVisible) {
		return null;
	}

	return (
		<div className="flex flex-col gap-12">
			<div className="flex w-100 justify-between items-center mb-8">
				<h2 className="m-0 size-24-bold text-black-100">{title}</h2>
				<TextBlackButton
					component={Link}
					to={`${generatePath(routing.paths.folder, { id: folderId })}/${type}`}
				>
					{t("folder.showAll", "Pokaż wszystkie")} &rarr;
				</TextBlackButton>
			</div>
			<div className="folder-items-grid">{children}</div>
		</div>
	);
};
